<template>
  <div>
    <el-form
      ref="form"
      :disabled="disabled"
      :model="formData"
      :rules="rules"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="this.$l('inspection_label_inspectionType') || '验货方式'"
          >
            <dict-select
              :placeholder="
                this.$l('tips_inspection_label_inspectionType') ||
                  '请选择验货方式'
              "
              size="small"
              clearable
              filterable
              v-model="formData.inspectionType"
              :body="inspectionTypeParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="this.$l('inspection_label_inspectionStage') || '验货阶段'"
          >
            <dict-select
              :placeholder="
                this.$l('tips_inspection_label_inspectionStage') ||
                  '请选择验货方式'
              "
              size="small"
              clearable
              filterable
              v-model="formData.inspectionStage"
              :body="inspectionStageParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="this.$l('inspection_label_inspectionTime') || '验货时间'"
            prop="inspectionTime"
          >
            <el-date-picker
              v-model="formData.inspectionTime"
              value-format="yyyy-MM-dd"
              type="date"
              style="width:100%"
              :placeholder="
                $l('form_label_pe_inspection_time') || '请选择验货时间'
              "
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="
              this.$l('inspection_label_inspectionRequirement') || '验货要求'
            "
          >
            <el-input
              v-model="formData.inspectionRequirement"
              type="textarea"
              :autosize="{ minRows: 4 }"
              :maxlength="500"
              show-word-limit
              :placeholder="
                $l('form_label_pe_inspection_requirements') || '请输入验货要求'
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <BatchTable
        ref="batchTable"
        :orderCode="orderCode"
        :orderInspectionCode="orderInspectionCode"
        :disabled="disabled"
      />
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import BatchTable from '../batch-table'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import dayjs from '@/libs/util.date'
export default {
  mixins: [EditLoading],
  components: { BatchTable },
  props: {
    orderInspectionCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    copyDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: { inspectionTime: dayjs(new Date()).format('YYYY-MM-DD') },
      backDialogVisible: false,
      inspectionTypeParams: { dictType: 'inspectionType' },
      inspectionStageParams: { dictType: 'inspectionStage' },
      rules: {
        inspectionType: [
          {
            required: true,
            message:
              this.$l('tips_inspection_label_inspectionType') ||
              '请选择验货方式',
            trigger: 'change',
          },
        ],
        inspectionStage: [
          {
            required: true,
            message:
              this.$l('tips_inspection_label_inspectionStage') ||
              '请选择验货阶段',
            trigger: 'change',
          },
        ],
        inspectionTime: [
          {
            required: true,
            message:
              this.$l('form_label_pe_inspection_time') || '请选择验货时间',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderInspectionCode) return
      this.$api
        .orderInspectionDetailApi({
          orderInspectionCode: this.orderInspectionCode,
        })
        .then((res) => {
          this.formData = res.body
          if (this.copyDisabled) {
            this.formData.orderInspectionCode = ''
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = true)

      const listBatchCode = await this.$refs.batchTable.getBatchCodes()
      if (!listBatchCode || !listBatchCode.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('form_label_pe_inspection_required_product') ||
            '请选择该验货要求的产品！',
          type: 'warning',
        })
        return
      }

      const params = {
        ...this.formData,
        orderCode: this.orderCode,
        listBatchCode,
      }
      this.loadingOpen()
      this.$api
        .orderInspectionSaveApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功',
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
